var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.company && _vm.office)?_c('company-show',_vm._g(_vm._b({attrs:{"no-company":""}},'company-show',{ company: _vm.company, office: _vm.office, staffItems: _vm.staffItems },false),{
    edit: _vm.edit,
    cancel: _vm.cancel,
    search: _vm.search,
    createStaff: _vm.createStaff,
    selectStaff: _vm.selectStaff,
    inviteStaff: _vm.inviteStaff,
    createStamp: _vm.createStamp
  })):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }